import { useStressAssessmentSchedule } from './hooks';
import { convertRowsToScheduleProps } from './logics/convertRowsToScheduleProps';
import { StressAssessmentSchedulePresentation } from './presentations';

export const StressAssessmentSchedule: React.FC = () => {
  const {
    state: { rows, isSaveLoading },
    actions: { onChangeMonth, onAddMonth, onRemoveMonth, onSubmit, onCancel },
  } = useStressAssessmentSchedule();

  const { monthRows, isAddDisabled } = convertRowsToScheduleProps(rows);

  return (
    <StressAssessmentSchedulePresentation
      monthRows={monthRows}
      onChangeMonth={onChangeMonth}
      onAddMonth={onAddMonth}
      onRemoveMonth={onRemoveMonth}
      onSubmit={onSubmit}
      onCancel={onCancel}
      isAddDisabled={isAddDisabled}
      isSaveLoading={isSaveLoading}
    />
  );
};
